import React, { useState, useEffect } from "react";

import onResize from "../../hoc/onResize";

import Burger from "./Burger";
import Link from "./Link";
import Dropdown from "./Dropdown";
import SearchForm from "./SearchForm";
import { ClickAwayListener } from "@mui/material";

export function SideBar(props) {
  const [open, setOpen] = useState(false);
  const {
    width,
    displaySearch,
    entity: { host },
    links,
  } = props;

  // Replace componentWillReceiveProps with useEffect
  useEffect(() => {
    setOpen(false);
  }, [width]);

  const burgerClick = () => {
    setOpen(!open);
  };

  const renderLinks = () => {
    const linkComponents = links.map((link) => {
      if (link.drop_down && link.dropdown_links) {
        return (
          <Dropdown
            key={link.id}
            className="sidebar-dropdown-container"
            dropdownClassName="sidebar-dropdown"
            parentLink={link}>
            {link.dropdown_links.map((dropDownLink) => (
              <li key={dropDownLink.id}>
                <Link {...dropDownLink} />
              </li>
            ))}
          </Dropdown>
        );
      } else {
        return <Link key={link.id} className="sidebar-item" {...link} />;
      }
    });
    return <div>{linkComponents}</div>;
  };

  let className = "microsite-sidebar primary-color-background";

  if (open) {
    className = `${className} open`;
  }

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <div>
        <Burger open={open} onClick={burgerClick} />
        <div className={className}>
          {displaySearch && <SearchForm host={host} />}
          {renderLinks()}
        </div>
      </div>
    </ClickAwayListener>
  );
}

SideBar.propTypes = {};

export default onResize(SideBar);
